import { profileApi } from './../../config/api-url';
import { Injectable } from '@angular/core';

import { ApiService } from './api.service';
import { sellerApi } from '../../config';

@Injectable({
  providedIn: 'root'
})
export class SellerService {

  constructor(private apiService: ApiService) { }

  getStandardIncentives(params: object): any {
    return this.apiService.get(sellerApi.getStandardIncentives, params as any);
  }

  getBonusIncentives(params: object): any {
    return this.apiService.get(sellerApi.getBonusIncentives, params as any);
  }

  salesDealsToClaimed(companyId: string | number, params: object): any {
    const url = sellerApi.salesDealsToClaimed.replace('{companyId}', String(companyId));
    return this.apiService.get(url, params as any);
  }

  activityDealsToClaimed(companyId: string | number, params: object): any {
    const url = sellerApi.activityDealsToClaimed.replace('{companyId}', String(companyId));
    return this.apiService.get(url, params as any);
  }

  claimedDeals(params: object): any {
    return this.apiService.get(sellerApi.claimedDeals, params as any);
  }

  pendingClaimedDeals(params: object): any {
    return this.apiService.get(sellerApi.pendingClaimedDeals, params as any);
  }

  claimDeal(claimId: string | number): any {
    return this.apiService.get(sellerApi.claimDeal + claimId);
  }

  getPointsAvailable(): any {
    return this.apiService.get(sellerApi.getPointsAvailable);
  }

  getCreditsAvailable(): any {
    return this.apiService.get(sellerApi.getCreditsAvailable);
  }

  getPointsGrsUrlForUser(pamData?: any): any {
    if (pamData == undefined) {
      pamData = '';
    }
    return this.apiService.get(sellerApi.getPointsGrsUrlForUser + pamData);
  }

  getCreditsGrsUrlForUser(): any {
    return this.apiService.get(sellerApi.getCreditsGrsUrlForUser);
  }

  getPrescribedEnablementsSeller(params: object): any {
    return this.apiService.get(sellerApi.getPrescribedEnablementsSeller, params as any);
  }

  getSaleChallengesSeller(params: object): any {
    return this.apiService.get(sellerApi.getSaleChallengesSeller, params as any);
  }

  claimDealByPo(params: object): any {
    return this.apiService.post(sellerApi.claimDealByPo, params);
  }

  getCoursesTakeClass(): any {
    return this.apiService.get(sellerApi.coursesTakeClass);
  }

  deleteChallenge(challengeId: string | number): any {
    return this.apiService.delete(sellerApi.deleteChallenge + '/' + challengeId);
  }

  getOtherChallengeDeals(companyId: string | number, params: object): any {
    return this.apiService.get(sellerApi.getOtherChallengeDeals + '/' + companyId + '/activationChallengeDeals', params as any);
  }

  getOtherChallengeCount(params: object): any {
    return this.apiService.get(sellerApi.getOtherChallengeCount, params as any);
  }

  centerDealsToClaimed(companyId: string | number, params: object): any {
    const url = sellerApi.centerDealsToClaimed.replace('{companyId}', String(companyId));
    return this.apiService.get(url, params as any);
  }

  nexuscenterDealsToClaimed(companyId: string | number, params: object): any {
    const url = sellerApi.nexuscenterDealsToClaimed.replace('{companyId}', String(companyId));
    return this.apiService.get(url, params as any);
  }

  blackBeltDealsToClaimed(companyId: string | number, params: object): any {
    const url = sellerApi.blackBeltDealsToClaimed.replace('{companyId}', String(companyId));
    return this.apiService.get(url, params as any);
  }

  blackBeltIOTDealsToClaimed(companyId: string | number, params: object): any {
    const url = sellerApi.blackBeltIOTDealsToClaimed.replace('{companyId}', String(companyId));
    return this.apiService.get(url, params as any);
  }

  getPointTransaction(body: object): any {
    return this.apiService.get(sellerApi.pointTransactionHistory, body as any);
  }

  getTicketTransaction(body: object): any {
    return this.apiService.get(sellerApi.ticketTransactionHistory, body as any);
  }

  securitySpringDealToClaimed(companyId: string | number, params: object): any {
    const url = sellerApi.securitySpringDealToClaimed.replace('{companyId}', String(companyId));
    return this.apiService.get(url, params as any);
  }

  collaborationSprintDealToClaimed(companyId: string | number, params: object): any {
    const url = sellerApi.collaborationSprintDealToClaimed.replace('{companyId}', String(companyId));
    return this.apiService.get(url, params as any);
  }

  cloudCallingToClaimed(companyId: string | number, params: object): any {
    const url = sellerApi.cloudCallingToClaimed.replace('{companyId}', String(companyId));
    return this.apiService.get(url, params as any);
  }

  getTicketRedemption(params: { userId: string | number }): any {
    return this.apiService.get(sellerApi.getTicketRedemption + '?userId=' + params.userId);
  }

  redeemTicketCatalog(params: { userId: string | number; catalogItemId: string | number }): any {
    return this.apiService.post(sellerApi.redeemTicketCatalog + '?userId=' + params.userId + '&catalogItemId=' + params.catalogItemId);
  }

  merakiToClaimed(companyId: string | number, params: object): any {
    const url = sellerApi.merakiToClaimed.replace('{companyId}', String(companyId));
    return this.apiService.get(url, params as any);
  }

  dnaToClaimed(companyId: string | number, params: object): any {
    const url = sellerApi.dnaToClaimed.replace('{companyId}', String(companyId));
    return this.apiService.get(url, params as any);
  }

  wanToClaimed(companyId: string | number, params: object): any {
    const url = sellerApi.wanToClaimed.replace('{companyId}', String(companyId));
    return this.apiService.get(url, params as any);
  }

  saseToClaimed(companyId: string | number, params: object): any {
    const url = sellerApi.saseToClaimed.replace('{companyId}', String(companyId));
    return this.apiService.get(url, params as any);
  }

  ibnToClaimed(companyId: string | number, params: object): any {
    const url = sellerApi.ibnToClaimed.replace('{companyId}', String(companyId));
    return this.apiService.get(url, params as any);
  }

  eaToClaimed(companyId: string | number, params: object): any {
    const url = sellerApi.eaToClaimed.replace('{companyId}', String(companyId));
    return this.apiService.get(url, params as any);
  }

  officeToClaimed(companyId: string | number, params: object): any {
    const url = sellerApi.officeToClaimed.replace('{companyId}', String(companyId));
    return this.apiService.get(url, params as any);
  }

  iotsalesToClaimed(companyId: string | number, params: object): any {
    const url = sellerApi.iotsalesToClaimed.replace('{companyId}', String(companyId));
    return this.apiService.get(url, params as any);
  }

  collabToClaimed(companyId: string | number, params: object): any {
    const url = sellerApi.collabToClaimed.replace('{companyId}', String(companyId));
    return this.apiService.get(url, params as any);
  }

  uploadAttachedDocument(filedata: object, param: string): any {
    return this.apiService.postForFile(profileApi.uploadAttachedDocument + param, filedata);
  }

  getNewSalesChallengeList(companyId: string | number, optionalParams?: string): any {
    return this.apiService.get(sellerApi.newSalesChallenge + '/' + companyId + '?' + optionalParams);
  }

  getChallengeDetails(dealId: string | number): any {
    return this.apiService.get(sellerApi.challengeDetails + '/' + dealId);
  }

  resendApprovalLink(req: string): any {
    return this.apiService.post(sellerApi.resendApprovalLink + req);
  }

  claimByPoSeller(params: string): any {
    return this.apiService.post(sellerApi.claimByPoSeller + params);
  }

  getsellerPointActivityData(params: string): any {
    return this.apiService.get(sellerApi.pointActivitySeller + params);
  }

  getSalesChallengeData(params: string): any {
    return this.apiService.get(sellerApi.salesChallengePerformence + params);
  }

  getLeaderTicketActivityData(params: string): any {
    return this.apiService.get(sellerApi.ticketActivity + params);
  }

  getClaimedData(params: string): any {
    return this.apiService.get(sellerApi.claimStatusSummary + params);
  }

  getStatisticsData(params: string): any {
    return this.apiService.get(sellerApi.statisticsData + params);
  }

  getDistributedPointActivity(params: string): any {
    return this.apiService.get(sellerApi.distributedPointActivity + params);
  }

  getSalesActivityData(params: string): any {
    return this.apiService.get(sellerApi.salesActivityData + params);
  }

  uploadActivityChallengeDocuments(filedata: object, params: string): any {
    return this.apiService.postForFile(sellerApi.uploadActivityChallengeDocuments + params, filedata);
  }

  uploadCompletion(fileData: object, params: string): any {
    return this.apiService.postForFile(sellerApi.uploadCompletion + params, fileData);
  }

  getCashEarnedData(): any {
    return this.apiService.get(sellerApi.cashBreakdown);
  }

  getpointsExpiryTrackerData(): any {
    return this.apiService.get(sellerApi.pointsExpiryTracker);
  }
}
